import { ERequestMethod } from '../../app.enums';
import { ApiUpdateRequest } from './api-update.request';

export class ApiPutRequest extends ApiUpdateRequest {
    public apiMethod = ERequestMethod.PUT;
}
